import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";

import Sidebar from "../StudentSidebar/Sidebar";
import SidebarItem from "../StudentSidebar/Props/SidebarItem";

const StudentLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const location = useLocation();
  const isStudentPage = location.pathname.includes("/student");

  if (!isStudentPage) return <main>{children}</main>;

  return (
    <div className="h-screen flex w-full">
      {/* Solo renderizar el Sidebar fijo en desktop */}
      <div className="sm:block sm:w-[23%]">
        <Sidebar>
          <SidebarItem icon="/assets/TableroB.png" text="Tablero" to="/student/tablero" />
          <SidebarItem icon="/assets/ModuleB.png" text="Módulos" to="/student/modules" />
          <SidebarItem icon="/assets/gradeB.png" text="Calificaciones" to="/student/grades" />
          <SidebarItem icon="/assets/paymentB.png" text="Historial Pagos" to="/student/payments" />
        </Sidebar>
      </div>

      {/* Contenido ocupa el 100% en mobile y 77% en desktop */}
      <div className="w-full  flex flex-col bg-gray-100 p-4 overflow-y-auto">
        <main className="flex-grow">{children}</main>
      </div>
    </div>
  );
};

export default StudentLayout;
